import { JIATextGenerationExtension } from './JIAExtension/JIATextGenerationExtension';
import { Editor } from 'tinymce';
import { MarkdownExtension } from './MarkdownExtension/MarkdownExtension';

export type TinyMCEExtension = {
    setup: (editor: Editor) => void;
};

export interface TinyMCEExtensionBuilder<T extends Array<any>> {
    (...args: T): TinyMCEExtension;
}

/*
 * To create a new extension follow these steps:
 *     - Create a folder for the extension
 *     - Create a builder for the extension using the builder type
 *     - Add your extension to the builders list bellow
 *
 * The commented code bellow shows how a dummy extension with a builder with no
 * arguments would be built and added to the list.
 *
 * Builders usage is delegated to core or extension.
 * Extension must be passed through the additionalExtensions prop of
 * JRCInputTinyMCE.
 */

/* *
const DummyExt : TinyMCEExtensionBuilder<[]> = () => {
    return {
        setup: (editor) => {

        }
    }
}
//*/

export const JTinyMCEExtensionsBuilders = {
    // dummyExt: DummyExt
    jia: JIATextGenerationExtension,
    markdown: MarkdownExtension,
} as const;
